export default __webpack_public_path__ + "static/media/pencilWhite.9489292d.svg";